<template>
  <!-- 以图搜图 -->
  <div class="page-collect-search-photo">
    <div class="sch-box">
      <!-- <el-upload ref="myUpload"
        class="upload-demo"
        action="#"
        list-type="picture-card"
        :limit="1"
        :auto-upload="false">
          <div slot="default" class="btn-upload" @click="fileList=[]"></div>
          <div slot="file" slot-scope="{file}">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url" alt=""
            >
          </div>
      </el-upload> -->

      <el-upload style="z-index: 2;"
        ref="myUpload"
        class="upload-demo"
        action="/singleMuseum/collection/picturesearch"
        :data="configData"
        :file-list="fileList"
        :limit="1"
        :auto-upload="false"
        list-type="picture"
        :on-success="handleAvatarSuccess"
        :on-change="handPic">
        <div class="btn-upload" v-show="pic" @click="handleClick"></div>
      </el-upload>

      <!-- <cmpUploadMainPhonto
        :callFun="getPhotoList"
        :fileList="pictureList"
        :showUpload="true"
        :showMainBtn="false"
        :multipleType="false"
        :showName="false"
      ></cmpUploadMainPhonto> -->
      <!-- <img class="upload-pic" src="http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg" alt=""> -->

      <a class="btn-digital mt-10" @click="handleSearch" style="z-index: 2;">以图搜图</a>

      <!-- <a class="clear" @click="handleClear">清除</a> -->
    </div>

    <div class="con-box" v-show="showRes">
      <div class="g-line"></div>

      <p class="res mt-20 mb-40">找到{{dataList.length}}条相似结果</p>

      <div class="list">
        <div class="item" v-for="(item, index) in dataList" :key="index" @click="showDetail(item)">
          <div class="pic-box">
            <img :src="item.mainPicture" alt="">
            <div class="tag-box">
              <span class="tag">{{item.collectDetailYear}}</span>
              <span class="tag">{{item.collectType}}</span>
            </div>
          </div>
          <div class="info">
            <h2>{{item.collectName}}</h2>
            <!-- <p>{{item.museumName}}</p> -->
          </div>
        </div>
      </div>
    </div>

    <add-collect ref="addCollect"></add-collect>
  </div>
</template>

<script>
import addCollect from './dialog-add-collect'
// import cmpUploadMainPhonto from '@cmp/my-upload/main-photo'
export default {
  components: { addCollect },
  // components: { cmpUploadMainPhonto },
  data() {
    return {
      configData: {
        // userId: this.$store.state.user.userid,
        // token: this.$store.state.user.token,
      },
      fileList: [],
      // pictureList: [
      //   {
      //     attPath: 'http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg'
      //   },
      // ],
      // dataList: [{name: '11', url: 'http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg'},{name: '11', url: 'http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg'},{name: '11', url: 'http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg'}, {name: '11', url: 'http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg'}],
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 10,
      },
      total: 0,
      showRes: false,
      pic:true
    }
  },
  methods: {
    showDetail(item) {
      // this.$refs['addCollect'].init('detail', '21010302wwglzx862109Z100828053845780')
      this.$refs['addCollect'].init('detail', item.collectId)
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    getPhotoList() {

    },
    handPic(){
      this.pic = false
    },
    handleClick() {
      this.showRes = false
      this.fileList = []
    },
    handleClear() {
      this.fileList = []
      this.pic = true
    },
    handleSearch() {
      console.log(345, this.fileList)
      // 重新上传
      if(this.showRes) {
        this.fileList = []
        this.pic = true
        return
      }

      if(!this.$refs.myUpload.uploadFiles || !this.$refs.myUpload.uploadFiles.length) {
        this.$message.warning('请先添加图片')
        return
      }
      this.$refs.myUpload.submit()
    },
    handleAvatarSuccess(res) {
      console.log(123, this.fileList)

      this.showRes = true
      if (res.success) {
        this.dataList = res.result
      } else {
        this.$message.error(res.message)
      }
    },
    goDetail(item) {
      this.$router.push({
        path: '/collect/detail',
        query: {id: item.id}
      })
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.page-collect-search-photo {
  width: 100%;
  // .upload-demo {
  //   /deep/ .el-upload--picture-card {
  //     width: auto;
  //     height: auto;
  //   }
  // }
  .upload-demo {
    .btn-upload {
      position: relative;
      z-index: 3;
      width: 408px;
      height: 212px;
      background: url(~@images/upload-add-2.png) no-repeat center center;
      background-size: 100% 100%;
    }
    /deep/ .el-upload-list {
      position: absolute;
      left: 15px;
      top: 15px;
      width: calc(100% - 30px);
      height: calc(100% - 30px);
      padding: 0;
      .el-upload-list__item-name {
        display: none;
      }
      .el-icon-close {
        display: none;
      }
      .el-upload-list__item {
        padding: 0;
        margin-top: 0;
        margin-bottom: 10px;
        border-radius: 0;
        // width: 120px;
        // height: 80px;
        width: 100%;
        height: 100%;
        border: none;
        background: transparent;
        .el-upload-list__item-thumbnail {
          float: none;
          margin: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          background: #e5f6ed;
        }
      }
    }
  }

  .sch-box {
    position: relative;
    margin-bottom: 40px;
    height: 400px;
    // background: url(~@images/sch-bg.png) no-repeat center center;
    // background-size: 100% 100%;
    background: #e5f6ed;
    border: solid 1px rgba(#306159, .3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .upload-pic {
      position: absolute;
      left: 15px;
      top: 15px;
      width: calc(100% - 30px);
      height: calc(100% - 30px);
    }

    .clear {
      color: #fff;
      position: relative;
      z-index: 999;
    }
  }

  .btn-digital {
    display: inline-block;
    color: #fff;
    width: 186px;
    height: 36px;
    // background: #000;
    background: url(~@images/btn-level-1.png) no-repeat center center;
    background-size: 100% 100%;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }

  .con-box {
    padding: 30px;
    background: #fff;

    .res {
      margin-bottom: 20px;
      font-size: 20px;
      color: #333;
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    min-height: 300px;
    .item {
      width: 32%;
      margin-bottom: 20px;
      // background: url(~@images/g-card-1-bg.png) center center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      img {
        width: 100%;
        height: 288px;
        object-fit: contain;
        background: #ccc;
        transition: all 0.6s;
      }
      &:not(:nth-child(3n)) {
        // margin-right: calc(4% / 2);
        margin-right: 2%;
      }
      &:hover {
        .pic-box {
          img {
            transform: scale(1.1);
          }
        }
      }
      .pic-box {
        position: relative;
        background: #ececec;
        overflow: hidden;
        // img {
        //   object-fit: contain;
        // }
        .tag-box {
          display: flex;
          position: absolute;
          bottom: 16px;
          left: 16px;
          .tag {
            display: inline-block;
            padding: 4px 12px;
            margin-right: 10px;
            font-size: 14px;
            color: #fff;
            background: #68a58e;
          }
        }
        .icon-3d {
          width: 48px;
          height: 35px;
          // background: url(~@images/icon-3d.png) no-repeat center center;
          background-size: 100% 100%;
          position: absolute;
          left: 10px;
          top: 10px;
        }
        .icon-play {
          width: 50px;
          height: 50px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          // background: url(~@images/icon-play.png) no-repeat center center;
          background-size: 100% 100%;
        }
        .name-fl {
          padding: 5px 8px;
          color: #fff;
          font-size: 12px;
          background: $primary;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .info {
        position: relative;
        padding: 20px 16px;
        font-size: 14px;
        color: #999493;
        h2 {
          font-size: 18px;
          font-weight: bold;
          color: #292423;
          margin-bottom: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .desc {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .tag-box {
            display: flex;
            .tag {
              display: inline-block;
              padding: 7px 12px;
              margin-right: 10px;
              font-size: 14px;
              color: #fff;
              background: #68a58e;
            }
          }
          .desc-r {
            .count {
              margin-right: 8px;
              font-size: 24px;
              color: #68a58e;
            }
          }
          .price {
            font-size: 22px;
            color: #995314;
          }
        }
      }
    }
  }

  /deep/ .cmp-main-photo {
    position: relative;
    z-index: 2;
    .uploader .uploader-btn {
      width: 408px;
      height: 212px;
      background: url(~@images/upload-add-2.png) no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
</style>

